export default (node) => {
  const faqQuestions = node.querySelectorAll('[data-faq-question]');
  const faqAnswers = node.querySelectorAll('[data-faq-answer]');

  // Toggle FAQ answer
  const toggleFaqAnswer = (event) => {
    const questionButton = event.currentTarget;
    const questionId = questionButton.getAttribute('data-faq-question');
    const answer = node.querySelector(`[data-faq-answer="${questionId}"]`);
    const plusIcon = questionButton.querySelector('[data-plus]');
    const minusIcon = questionButton.querySelector('[data-minus]');

    if (answer.style.maxHeight && answer.style.maxHeight !== '0px') {
      // Collapse the answer
      answer.style.maxHeight = '0px';
      plusIcon.style.display = 'block';
      minusIcon.style.display = 'none';
    } else {
      // Expand the answer
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      plusIcon.style.display = 'none';
      minusIcon.style.display = 'block';
    }
  };

  const init = () => {
    faqAnswers.forEach((answer) => {
      answer.style.maxHeight = '0px'; // Collapsed
      answer.style.overflow = 'hidden'; // Prevent overflow
      answer.style.transition = 'max-height 0.3s ease'; // Smooth transitions
    });

    // Hide all minus icons initially
    faqQuestions.forEach((question) => {
      const minusIcon = question.querySelector('[data-minus]');
      minusIcon.style.display = 'none';
      question.addEventListener('click', toggleFaqAnswer);
    });
  };

  init();
};
